import { render, staticRenderFns } from "./logisticsSetup.vue?vue&type=template&id=2f7d86e0&scoped=true&"
import script from "./logisticsSetup.vue?vue&type=script&lang=js&"
export * from "./logisticsSetup.vue?vue&type=script&lang=js&"
import style0 from "./logisticsSetup.vue?vue&type=style&index=0&id=2f7d86e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7d86e0",
  null
  
)

export default component.exports